import { motion } from "framer-motion";
import { GraduationCap, Rocket, MessagesSquare, ShieldCheck } from "lucide-react";
import { Reveal, staggerParent, staggerChild } from "./Reveal";
import { IMG } from "../../lib/assets";

const PRIORITIES = [
  {
    n: "01",
    icon: GraduationCap,
    title: "Student Success",
    body: "Supporting learning environments where every student can reach their full potential.",
  },
  {
    n: "02",
    icon: Rocket,
    title: "Future Ready Education",
    body: "Encouraging innovation, technology, and opportunities that prepare students for tomorrow.",
  },
  {
    n: "03",
    icon: MessagesSquare,
    title: "Parent Engagement",
    body: "Ensuring families have a meaningful voice in decisions affecting their children.",
  },
  {
    n: "04",
    icon: ShieldCheck,
    title: "Accountability & Transparency",
    body: "Responsible decision-making and stewardship of public resources.",
  },
];

export const Priorities = () => {
  return (
    <section id="priorities" className="py-20 lg:py-32 bg-white" data-testid="priorities-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <Reveal className="lg:col-span-7">
            <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-600">My Priorities</p>
            <h2 className="font-display font-extrabold tracking-tight text-slate-900 text-3xl md:text-4xl lg:text-5xl mt-3 leading-tight">
              A practical plan built around students and families
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5">
            <div className="rounded-2xl overflow-hidden border border-slate-200 h-40">
              <img src={IMG.classroom} alt="Students learning in a modern classroom" className="w-full h-full object-cover" />
            </div>
          </Reveal>
        </div>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid sm:grid-cols-2 gap-6"
        >
          {PRIORITIES.map((p) => (
            <motion.div
              key={p.title}
              variants={staggerChild}
              className="group relative overflow-hidden rounded-2xl border border-slate-200 p-8 bg-white hover:bg-teal-50/60 transition-colors duration-300"
              data-testid={`priority-card-${p.n}`}
            >
              <span className="absolute top-6 right-7 font-display text-5xl font-extrabold text-slate-100 group-hover:text-teal-100 transition-colors">
                {p.n}
              </span>
              <div className="inline-flex items-center justify-center rounded-xl bg-slate-900 text-white p-3 group-hover:bg-teal-600 transition-colors">
                <p.icon size={26} strokeWidth={1.75} />
              </div>
              <h3 className="font-display text-2xl font-bold tracking-tight text-slate-900 mt-6 relative z-10">
                {p.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed max-w-md relative z-10">{p.body}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
